module.exports = __webpack_public_path__ + "img/phone2.caad8af7.png";